import lang from '../components/language/services/Lang';
import auth from '../services/auth/AuthProvider';
import { RouteConstants } from '../router/services/RouteConstants';
import { useHistory } from 'react-router-dom'

export const useDoxExplorerParent = () => {
    const history = useHistory();

    const translateString = (key, params) => {
        return lang.getCurrentValue(key, params)
    }

    const handleUnauthorized = () => {
        if (auth.isAuthenticated()) {
            auth.logout();
            return;
        }
        history.push(RouteConstants.LOGOUT);
    }

    return [translateString, handleUnauthorized]
}